module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"btn":{"selectFile":"Select File"}},"ko":{"btn":{"selectFile":"파일 선택"}}}')
  delete Component.options._Ctor
}
